import { getEmptyTranslations } from '@/configuration/pages/ConfigurationPage/helpers'

export const getSavePreferencesPayload = ({
  backgroundColor,
  textColor,
  linkColor,
  useCustomText,
  customTexts,
  supportedLanguages,
}) => {
  const emptyTranslations = getEmptyTranslations(supportedLanguages)

  return {
    background_color: backgroundColor,
    text_color: textColor,
    link_color: linkColor,
    text: useCustomText ? customTexts.text : emptyTranslations,
  }
}
